const PubSub = require("underpub-js");
const { gsap } = require("gsap/dist/gsap");
const { ScrollTrigger } = require("gsap/dist/ScrollTrigger");

gsap.registerPlugin(ScrollTrigger);

const moreListings = function(options) {
	this.options = {
		$el: false,
		baseClass: "comp-MoreListings",
	};

	$.extend(true, this.options, options);

	this.navTL;
};

moreListings.prototype.init = function() {
	
	const self = this;

	self.filtersDropdownOpen = false;

	self.$filtersDropdownToggle = self.options.$el.find(`.${self.options.baseClass}__filtersDropdown__toggle`);
	self.$filtersDropdownToggleArrow = self.options.$el.find(`.${self.options.baseClass}__filtersDropdown__toggle__arrow`);
	self.$filtersWrapper = self.options.$el.find(`.${self.options.baseClass}__filtersDropdown__filtersWrapper`);

	self.initFiltersDropdown();

};

moreListings.prototype.initFiltersDropdown = function() {

	const self = this;

	self.$filtersDropdownToggle.on('click', function() {

		if (self.filtersDropdownOpen) {
			self.closeFiltersDropdown();
		}
		else {
			self.openFiltersDropdown();
		}

	});

};

moreListings.prototype.openFiltersDropdown = function() {

	const self = this;

	self.filtersDropdownOpen = true;

	gsap.timeline({

	})
	.to(self.$filtersWrapper, {
		duration: 0.35,
		height: "auto"
	})
	.to(self.$filtersDropdownToggleArrow, {
		duration: 0.35,
		rotation: 0
	}, "<");

};

moreListings.prototype.closeFiltersDropdown = function() {

	const self = this;

	self.filtersDropdownOpen = false;

	gsap.timeline({

	})
	.to(self.$filtersWrapper, {
		duration: 0.25,
		height: 0
	})
	.to(self.$filtersDropdownToggleArrow, {
		duration: 0.25,
		rotation: 180
	}, "<");

};

module.exports = moreListings;
